/**
 * Created by 胜龙 on 2018/1/25.
 */
!function (a, b, c) {
  function d(a) {
    var c = "default";
    a.self_redirect === !0 ? c = "true" : a.self_redirect === !1 && (c = "false");
    var d = b.createElement("iframe"),
      e = "http://open.weixin.qq.com/connect/qrconnect?appid=" + a.appid + "&scope=" + a.scope + "&redirect_uri=" + a.redirect_uri + "&state=" + a.state + "&login_type=jssdk&self_redirect=" + c;
    e += a.style ? "&style=" + a.style : "", e += a.href ? "&href=" + a.href : "", d.src = e, d.frameBorder = "0", d.allowTransparency = "true", d.scrolling = "no", d.width = "65%", d.height = "100%";
    var f = b.getElementById(a.id);
    if(f!=null){
      f.innerHTML = "", f.appendChild(d)
    }
  }
  a.WxLogin = d
}(window, document);



// WEBPACK FOOTER //
// ./src/assets/wxLogin.js